import { useEffect, useRef, useState } from 'react'
import PlayNavigation from './PlayNavigation'
import styles from './PlayDesktopNavigation.module.scss'

export default function PlayDesktopNavigation() {
  const [dismissed, setDismissed] = useState(false)
  const railRef = useRef<HTMLElement>(null)

  useEffect(() => {
    const dismissHoveredRail = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && !event.defaultPrevented && railRef.current?.matches(':hover')) {
        setDismissed(true)
      }
    }
    window.addEventListener('keydown', dismissHoveredRail)
    return () => window.removeEventListener('keydown', dismissHoveredRail)
  }, [])

  return (
    <aside
      ref={railRef}
      className={styles.rail}
      data-testid="play-navigation-rail"
      data-dismissed={dismissed || undefined}
      onPointerEnter={() => setDismissed(false)}
      onFocusCapture={() => setDismissed(false)}
      onKeyDown={event => {
        if (event.key !== 'Escape') return
        event.preventDefault()
        event.stopPropagation()
        setDismissed(true)
      }}
    >
      <PlayNavigation />
    </aside>
  )
}
